
import React, { useState, useEffect, useRef, useContext } from "react";
import Category from "./Category";
import EmptyProperty from "./EmptyProperty";
import Property from "./Property";
export function Item({ parents, property , totalChecked , setTotalChecked, propertyProduct}) {

  return (
    <>
      {parents && (
        <>
          <div className="item">
            <Category parents={parents} />
            {property &&
              parents.property.map((item_property) => (
                <div key={item_property.id}>
                  {item_property.property_id == null && (
                    <Property
                      properties={parents.property}
                      item_property={item_property}
                      totalChecked={totalChecked}
                      setTotalChecked={setTotalChecked}
                      propertyProduct={propertyProduct}
                    />
                  )}
                </div>
              ))}
            {parents.property.length == 0 && <EmptyProperty />}
          </div>
          {parents.parents && (
            <Item
              parents={parents.parents}
              property={parents.property}
              totalChecked={totalChecked}
              setTotalChecked={setTotalChecked}
              propertyProduct={propertyProduct}
            />
          )}
        </>
      )}
    </>
  );
}
